<script lang="ts">
  import Divider from "./Divider.svelte";
</script>

<main class="mx-4 -mb-24">
  <div
    class="grid md:grid-cols-[minmax(16rem,2fr)_minmax(0,8fr)] 2xl:grid-cols-[22rem_minmax(0,11fr)]"
  >
    <div class="pb-8">
      <div class="scroller sidebar h-56 md:h-[calc(100vh-98px)]">
        <slot name="sidebar-links" />
      </div>
    </div>
    <!-- Divider to split nav and text in single-column layout -->
    <div class="visible w-90 md:hidden">
      <Divider />
    </div>
    <div class="flex w-full justify-center border-divider md:border-l">
      <div
        class="grid w-full max-w-(--breakpoint-xl) grid-cols-1 md:pr-4 md:pl-8 lg:grid-cols-[minmax(0,8fr)_minmax(0,3fr)] lg:gap-4 lg:pr-0"
      >
        <slot />
      </div>
    </div>
  </div>
</main>

<style lang="postcss">
  @reference "$app.css";

  .sidebar {
    @apply sticky top-[65px] mt-2 mr-1 flex flex-col pt-2 pr-1 pb-2;
  }

  .scroller {
    overflow-y: auto;
    overflow-y: overlay;
    scrollbar-color: transparent transparent; /* Firefox only */
  }

  .scroller:hover {
    scrollbar-color: var(--semantic-border-primary) transparent; /* Firefox only */
  }

  .scroller::-webkit-scrollbar {
    width: 8px;
  }

  .scroller::-webkit-scrollbar-thumb {
    background: transparent; /* Safari fix */
    border-radius: 10px;
  }

  .scroller:hover::-webkit-scrollbar-thumb {
    background: var(--semantic-border-primary); /* Safari fix */
  }
</style>
